import { CardSuggestionDto } from "./card-suggestion.dto";

export class CardSuggestionTranslationDto{
    /*
    *
    */
    constructor(
      public id?:  number,
      public title?: string,
      public location?: string,
      public details?: string,
      public link?: string,
      public locale?: string,
      public cardSuggestions?: CardSuggestionDto
    ){}
}